(function () {
  function detectPlatform() {
    var normalized = window.navigator.userAgent.toLowerCase();
    var isAndroid = normalized.indexOf("android") !== -1;
    var isIOS =
      /iphone|ipad|ipod/.test(normalized) ||
      (normalized.indexOf("macintosh") !== -1 && window.navigator.maxTouchPoints > 1);

    if (isAndroid) return "android";
    if (isIOS) return "ios";
    return "desktop";
  }

  function fallbackUrl(config, platform) {
    return platform === "ios" ? config.iosUrl : config.androidUrl;
  }

  document.addEventListener("DOMContentLoaded", function () {
    var root = document.querySelector("[data-odyss-guide]");
    if (!root) return;

    var status = root.querySelector("[data-odyss-guide-status]");
    var primary = root.querySelector("[data-odyss-guide-primary]");
    var platform = detectPlatform();
    var primaryPlatform = platform === "ios" ? "ios" : "android";
    var config = {
      appSchemeUrl: root.dataset.appSchemeUrl || "odyss://",
      universalLinkUrl: root.dataset.universalLinkUrl || "",
      iosUrl: root.dataset.iosUrl || "https://testflight.apple.com/join/crydBtsB",
      androidUrl: root.dataset.androidUrl || "https://api-test.odyss.life/api/v1/app/test-apk/download",
      fallbackDelayMs: Number(root.dataset.fallbackDelayMs || 1400),
    };

    if (primary) {
      primary.href = fallbackUrl(config, primaryPlatform);
      primary.textContent = primaryPlatform === "ios" ? "Continue on iPhone" : "Continue on Android";
    }

    if (!status) return;

    if (platform === "desktop") {
      status.textContent = "Choose how to continue on your phone.";
      return;
    }

    var pageHidden = false;
    var fallbackTimer;

    document.addEventListener("visibilitychange", function () {
      if (document.visibilityState === "hidden") {
        pageHidden = true;
        if (fallbackTimer) window.clearTimeout(fallbackTimer);
      }
    });

    status.textContent = "Opening Odyss...";
    window.location.href = config.universalLinkUrl || config.appSchemeUrl;

    fallbackTimer = window.setTimeout(function () {
      if (pageHidden) return;
      status.textContent = "Opening the right guide...";
      window.location.href = fallbackUrl(config, platform);
    }, config.fallbackDelayMs);
  });
})();
